import { Button, Card, Table, TableBody, TableCell, TableHead, TableRow, Toolbar } from '@mui/material';
import { useGetList, useRecordContext } from 'react-admin';

import { CircularProgress } from '@mui/material';
import styled from 'styled-components';
import { useState } from 'react';

const NotificationHistory = () => {
  const record = useRecordContext();
  const [page, setPage] = useState(1);
  const perPage = 10;
  const { data, total, isLoading } = useGetList(`notifications/${record.id}/history`, {
    pagination: { page, perPage },
  });

  const formatToSimpleTime = (date?: string) => {
    if (date) {
      const currentDate = new Date(date);
      const day = currentDate.toLocaleDateString().replace(/\//g, '.');
      const time = currentDate.toLocaleTimeString();
      return day + ' ' + time;
    }
  };

  if (isLoading) {
    return (
      <Container>
        <CircularProgress />
      </Container>
    );
  }
  return (
    <div>
      <Card>
        <Table sx={{ padding: 2 }} size="small">
          <TableHead>
            <TableRow>
              <TableCell>Дата отправки</TableCell>
              <TableCell>Id администратора</TableCell>
              <TableCell>Почта администратора</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data &&
              data.map((notification) => (
                <TableRow key={notification.id}>
                  <TableCell>{formatToSimpleTime(notification.sentAt)}</TableCell>
                  <TableCell>{notification.administrator.id}</TableCell>
                  <TableCell>{notification.administrator.email}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </Card>
      <Toolbar>
        {page > 1 && <Button onClick={() => setPage(page - 1)}>Предыдущая страница</Button>}
        {total && page < total / perPage && <Button onClick={() => setPage(page + 1)}>Следующая страница</Button>}
      </Toolbar>
    </div>
  );
};

const Container = styled.div`
  margin: 10px auto;
`;

export default NotificationHistory;
